import type { ComponentType, ReactNode } from 'react';
import React from 'react';

// Type guard to check if the variable is of type ComponentType
export const isComponentType = (
	variable: any
): variable is ComponentType<any> => {
	return typeof variable === 'function';
};

// Type guard to check if the variable is of type ReactNode
export const isReactNode = (variable: any): variable is ReactNode => {
	return (
		typeof variable === 'string' ||
		typeof variable === 'number' ||
		React.isValidElement(variable)
	);
};

export const isCSSVariable = (variable: string): boolean => {
	const CSS_REGEX = /var\(([a-z-0-9,\s]+)\)/;
	return CSS_REGEX.test(variable);
};
